<h1>Crear Cuenta Usuario</h1>
<form [formGroup]="formUsuario" autocomplete="off" novalidate  fxLayout="column wrap"
fxLayoutAlign="center center" fxLayoutGap="10px">
    <mat-dialog-content>    
        <table>
            <tr>
                <td>Rut:</td>
                <td>
                    <mat-form-field>
                        <input matInput appRut type="text" class="input-rut"  formControlName="rut" id="rut" [errorStateMatcher]="stateRutValido">                             
                        <mat-error *ngIf="hasError('rut', 'required')">Rut es requerido</mat-error>
                        <p class="mat-error p-error" *ngIf="formUsuario.hasError('rutValido')">Ingrese un RUT válido</p>            
                    </mat-form-field>  
                </td>
                <td>
                    <button class="btn-buscar" (click)="buscar()" [disabled]="formUsuario.hasError('rutValido') || formUsuario.controls['rut'].value.length < 8">Buscar</button>
                </td>
            </tr>
            <tr>
                <td>Nombres:</td>
                <td colspan="2">
                    <mat-form-field>
                        <input matInput type="text" formControlName="nombre" id="nombre">                             
                        <mat-error *ngIf="hasError('nombre', 'required')">Nombres es requerido</mat-error>            
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Apellido Paterno:</td>
                <td colspan="2">
                    <mat-form-field>
                        <input matInput type="text" formControlName="apellidoPaterno" id="apellidoPaterno">                             
                        <mat-error *ngIf="hasError('apellidoPaterno', 'required')">Apellido Paterno es requerido</mat-error>            
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Apellido Materno:</td>
                <td colspan="2">
                    <mat-form-field>
                        <input matInput type="text" formControlName="apellidoMaterno" id="apellidoMaterno">                             
                        <mat-error *ngIf="hasError('apellidoMaterno', 'required')">Apellido Materno es requerido</mat-error>            
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Estamento:</td>
                <td colspan="2">
                    <mat-form-field>
                        <mat-select formControlName="estamento" id="estamento" name="estamento">
                            <mat-option [value]="0">Seleccione Modalidad</mat-option>
                            <mat-option [value]="estamentos.idTablaMaestra" *ngFor="let estamentos of dataSelects.estamentos">{{estamentos.descripcionLarga}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('estamento', 'required')">Estamento es requerido</mat-error>
                        <mat-error *ngIf="hasError('estamento', 'min')">Estamento es requerido</mat-error>
                    </mat-form-field>  
                </td>
            </tr>
            <tr>
                <td>Región:</td>
                <td colspan="2">
                    <mat-form-field>
                        <mat-select formControlName="region" id="region" name="region"  (selectionChange)="seleccionarRegion()">
                            <mat-option [value]="0">Seleccione Región</mat-option>
                            <mat-option [value]="regiones.idRegion" *ngFor="let regiones of dataSelects.regiones">{{regiones.nombre}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('region', 'required')">Región es requerido</mat-error>
                        <mat-error *ngIf="hasError('region', 'min')">Región es requerido</mat-error>
                    </mat-form-field>     
                </td>
            </tr>
            <tr>
                <td>Comuna:</td>
                <td colspan="2">
                    <mat-form-field>
                        <mat-select formControlName="comuna" id="comuna" name="comuna">
                            <mat-option [value]="-1">Seleccione Comuna</mat-option>
                            <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('comuna', 'required')">Comuna es requerido</mat-error>
                        <mat-error *ngIf="hasError('comuna', 'min')">Comuna es requerido</mat-error>
                    </mat-form-field> 
                </td>
            </tr>
            <tr>
                <td>Correo Electrónico:</td>
                <td colspan="2">
                    <mat-form-field>
                        <input matInput type="text" formControlName="correo" id="correo">                             
                        <mat-error *ngIf="hasError('correo', 'required')">Correo Electrónico es requerido</mat-error>            
                    </mat-form-field>
                </td>
            </tr>
        </table> 
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <div class="button-row"> 
            <button mat-button mat-dialog-close class="btn-cancelar">Cancelar</button>
            <button mat-button class="btn-confirmar" (click)="guardar()">Guardar</button>
        </div>
    </mat-dialog-actions>
</form>